import { render, staticRenderFns } from "./StreamTabWebinar.vue?vue&type=template&id=532c50f8&scoped=true&"
import script from "./StreamTabWebinar.vue?vue&type=script&lang=js&"
export * from "./StreamTabWebinar.vue?vue&type=script&lang=js&"
import style0 from "./StreamTabWebinar.vue?vue&type=style&index=0&id=532c50f8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532c50f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VCard,VIcon,VSheet})
